"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChatThread = void 0;
var account_1 = require("../account");
var content_1 = require("../content");
var chat_message_1 = require("./chat-message");
var chat_thread_participant_1 = require("./chat-thread-participant");
var ChatMessageDateProperties = ['created_at', 'updated_at'];
var ChatThread = /** @class */function () {
  function ChatThread(values) {
    if (values === void 0) {
      values = {};
    }
    this.messages_count = 0;
    this.unread_count = 0;
    var properties = Object.getOwnPropertyNames(values);
    var instance = this;
    properties.forEach(function (p) {
      if (p in values) {
        instance[p] = values[p];
      }
      if (ChatMessageDateProperties.includes(p) && values[p]) {
        instance[p] = new Date(values[p].toString());
      }
    });
    instance.participants = (values.participants || []).map(function (tp) {
      return new chat_thread_participant_1.ChatThreadParticipant(tp);
    });
    instance.messages = (values.messages || []).map(function (message) {
      return new chat_message_1.ChatMessage(message);
    });
    if (values.meeting) {
      instance.meeting = new content_1.Meeting(values.meeting);
    }
    if (values.person) {
      instance.person = new account_1.User(values.person);
    }
    if (values.latest_message) {
      instance.latest_message = new chat_message_1.ChatMessage(values.latest_message);
    }
    return this;
  }
  /** Получение заголовка в новом стиле  */
  ChatThread.prototype.getTitle = function (imageSize) {
    if (imageSize === void 0) {
      imageSize = 'sm';
    }
    var title = '';
    if (this.meeting) {
      title = this.meeting.title;
    }
    if (this.person) {
      title = this.person.first_name + ' ' + this.person.last_name;
    }
    return title;
  };
  /** Получение картинки в новом стиле */
  ChatThread.prototype.getCoverPicUrl = function (imageSize) {
    if (imageSize === void 0) {
      imageSize = 'sm';
    }
    var coverPicUrl = '';
    if (this.meeting) {
      if (this.meeting.cover && this.meeting.cover[imageSize]) {
        coverPicUrl = this.meeting.cover[imageSize].url;
      }
    }
    if (this.person) {
      if (this.person.userpic && this.person.userpic[imageSize]) {
        coverPicUrl = this.person.userpic[imageSize].url;
      }
    }
    return coverPicUrl;
  };
  return ChatThread;
}();
exports.ChatThread = ChatThread;
